import React from "react";
import { Linkedin, Facebook, Youtube } from "lucide-react";
import "./RightSide.css";

const RightSide = () => {
  return (
    <div className="page">
      {/* HERO */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-content">
            <h2>Contact</h2>
            <p>
              SALIS ERP SYSTEM provides cloud-based, fully customizable ERP
              software designed to enhance your business growth.
            </p>

            <div className="contact-item">📞 +880 1537-570379</div>
            <div className="contact-item">✉ info@deshit-bd.com</div>



            <div className="socials">



              <a href="https://www.linkedin.com/company/deshit-bd" target="_blank">
                <div className="social-circle linkedin">
                  <Linkedin size={20} />
                </div>
              </a>
              <a href="https://www.facebook.com/ERP.Salis" target="_blank">
                <div className="social-circle facebook">
                  <Facebook size={20} />
                </div>
              </a>
              <a href="https://www.youtube.com/watch?v=VqanJ_z9j1M" target="_blank">

                <div className="social-circle youtube">
                  <Youtube size={20} />
                </div>
              </a>
            </div>

          </div>

          <div className="hero-image">
            <img src="./images/mobilescreen.svg" alt="Mobile App" />
          </div>
        </div>
      </section>

      {/* DASHBOARD IMAGE */}
      <section className="dashboard-image">
        <img src="./images/desktopscreen.svg" alt="Dashboard" />
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>
          Make Your Business Systematic And <br />
          Easy To Manage
        </h2>
      </section>
    </div>
  );
};

export default RightSide;
